export default {
	sections: 'الأقسام',
	employees: 'الموظفين',
	work: 'الدوام',
	salaries: 'الرواتب',
	'penalties-and-rewards': 'العقوبات والمكافآت',
	settings: 'الإعدادات',
	'penalties-and-rewards-types': 'أنواع العقوبات والمكافآت',
	'trainings': 'التدريب والتطوير',
	'add-attendance-type': 'أنواع الدوام',
	'add-personal-information': 'المعلومات الشخصية',
	reminders: 'التذكيرات',
	evaluations: 'التقييمات',
	interviews: 'الأداء والتقييم',
};
